export const route = {
  ORDER_LIST: "/api/orders",

  RUNNING_ORDER_LIST: "/api/orders/running-order-list",
  IN_COMPLETE_ORDER_LIST: "/api/orders/in-complete-order-list",
  ORDER_LIST_HISTORY: "/api/orders/order-list-history",
  ORDER_STATUS_LIST_BY_ID: "/api/orders/order-status-list-by-id",

  ORDER_STATUS_BY_ORDER_ID: "/api/orders/order_current_status_by_order_id", // :id
  ORDER_STATUS_CHANGE: "/api/orders/order_status_change", // { event, order_id }
  ORDER_LIST_STATUS_DATA_FOR_LAST_SEVEN_DAY: "/api/orders/last-seven-days",
  // campaigns
  GET_CAMPAIGNS: "/api/campaign/get_campaigns",
  GET_CAMPAIGN_PRODUCT_LIST: "/api/campaign/product_list",
  ADD_PRODUCT_TO_CAMPAIGN: "/api/campaign/add_product_to_campaign",
  UPDATE_PRODUCT_LIST_TO_CAMPAIGN: "/api/campaign/udpate_sorted_product_list",
  DELETE_CAMPAIGN: "/api/campaign/delete_campaign",
  REMOVE_PRODUCT_FROM_CAMPAIGN: "/api/campaign/remove_product_from_campaign",
  PAYMENT_REQUEST_COUNT: "/api/sellers/total_new_payment_req_count",
  SELLER_SERVICE_AREA_UPDATE: "/api/sellers/update-seller-service-area",

  // Express Default Delivery
  GET_EXPRESS_DEFAULT_DELIVERY: "/api/orders/get-default-deliery-config",
  UPDATE_EXPRESS_DEFAULT_DELIVERY: "/api/orders/update-default-deliery-config",

  // Products
  GET_ALL_PRODUCT_LIST: "/api/products/all_products",
  GET_PRODUCT_DETAILS: "/api/products/get_product_detail",
  CHECK_SLUG_AVAILAVILITY: "/api/products/check_slug_is_available",
  PRODUCT_IMAGE_PROCESS: "/api/products/product_image_process",
  PRODUCT_IMAGE_PROCESS_LIST: "/api/products/image-process-list",
  CHANGE_PRODUCT_CHANGE: "/api/products/change_product_status",
  ALL_PRODUCT_PHOTO_PROCESS: "/api/products/vendor-image-process",
  PHOTO_RE_PROCESS: "/api/products/image-re-process",
  PROCESS_REMAINING_COUNT: "/api/products/process_remaining_count",
  TODAY_IMAGE_PROCESSED: "/api/products/today_image_processed",
  REMOVE_PROCESSED_IMAGE: "/api/products/remove_error_image",
  CHANGE_FREE_DELIVERY_STATUS: "/api/products/change_product_delivery",
  MAKE_FEATURED_PRODUCT: "/api/products/make_featured",
  MAKE_MALL_PRODUCT: "/api/products/make_mall_product",
  REMOVE_MALL_PRODUCT: "/api/products/remove_mall_product",
  DELETE_PRODUCTS: "/api/products/delete_products",
  DELETE_STOCK_OUT_PRODUCTS: "/api/products/delete_stock_out_products",

  // ==============================
  GET_SALES_CAMPAIGN_LIST: "/api/sales/get_sales",
  SET_SALES_CAMPAIGN_TO_PRODUCT: "/api/sales/add_to_sale",

  // banner
  DELETE_BANNER_BY_ID: "/api/sales/delete-banner-by-id",
  UPDATE_BANNER_BY_ID: "/api/sales/update-sorted-banner",

  // banner esentials
  GET_CATEGORIES_BY_SEARCH: "/api/sales/get_categories",
  GET_SUB_CATEGORIES_BY_SEARCH: "/api/sales/get_sub_categories",
  GET_PRODUCTS_BY_SEARCH: "/api/sales/get_products",
  GET_CAMPAIGN_BY_SEARCH: "/api/sales/get_campaigns",
  GET_SERVICE_BY_SEARCH: "/api/sales/get_services",
  GET_SELLER_SHOP_BY_SEARCH: "/api/sales/get_seller_shops",

  // customers
  ADD_NEW_CUSTOMER: "/api/customers/add-new-customer",
  CUSTOMER_LIST: "/api/customers/get_customers",

  // vendor
  // change vendor is open or close
  // change vendor timings
  UPDATE_SELLER_SHOP_TIMING: "/api/sellers/edit_seller_timings",
  UPDATE_SELLER_SHOP_OPEN_CLOSE_STATE: "/api/sellers/open_close_controll",
  UPDATE_SELLER_COMMISSION: "/api/sellers/update_seller_commission",
  GET_SELLER_LIST: "/api/sellers/get_sellers",
  GET_SELLER_PRODUCT_LIST: "/api/sellers/get_seller_product_list",
  GET_RECENT_SELLER_LIST: "/api/sellers/get_recent_sellers",
  GET_SELLER_ORDER_REVIEWS: "/api/sellers/get_reviews",
  ORDER_DETAILS_V4: "/api/orders/order_details_v4",

  // courier
  COURIER_PROVIDERS: "/api/courier/providers",
  COURIER_SEND_PACKAGE: "/api/courier/send-package",
  COURIER_REFRESH_STATUS: "/api/courier/refresh-status",
  COURIER_SEND_ORDER: "/api/courier/send-order",
  COURIER_REFRESH_ORDER_STATUS: "/api/courier/refresh-order-status",

  // seller transections
  SELLER_TRANSECTION_LIST: "/api/sellers/get_vendor_transections",
  SELLER_PAYMENT_PAY: "/api/sellers/add_seller_transection",
  SELLER_TOTAL_SALE_AMOUNT: "/api/sellers/get_vendor_total_sale_amount",
  SELLER_TOTAL_REVENUE: "/api/sellers/get_vendor_total_revenue_amount",
  SELLER_TOTAL_PAID_AMOUNT: "/api/sellers/get_vendor_total_paid_amount",
  SELLER_TOTAL_CURRENT_BALANCE_AMOUNT: "/api/sellers/get_vendor_balance",
  SELLER_BALANCE_ADJUSTMENT: "/api/sellers/adjust-seller-balance",
  SELLER_FREE_DELIVERY_UPDATE: "/api/sellers/allow-free-delivery-status-update",

  SELLER_TRANSECTION_QUEUE: "/api/sellers/seller_transection_queue",
  RIDER_TRANSECTION_QUEUE: "/api/sellers/rider_transection_queue",
  TRANSECTION_PROCESS_MANUALLY: "/api/sellers/process-transection-manually",

  // refund order
  REFUND_ORDER_PAYMENT: "/api/orders/refund-order",
  RESET_ORDER_STATUS: "/api/orders/revert_order_status",
  REMOVE_PRODUCT_FROM_CART: "/api/orders/remove_product_from_cart",
  CHANGE_ORDER_PAYMENT_METHOD: "/api/orders/change_order_payment_method",
  ORDER_NOTIFICATION_SEND: "/api/orders/send-notification-to-order",
  ADJUST_ORDER_PRODUCT_QTY: "/api/orders/adjust-order-product-qty",

  // order note
  ADD_ORDER_NOTE: "/api/orders/add-order-note",
  UPDATE_ORDER: "/api/orders",
  UPDATE_ORDER_PRODUCTS: "/api/orders",
  LIST_ORDER_NOTE: "/api/orders/get-order-note",
  GET_TOTAL_USER_SPENDING_AMOUNT: "/api/orders/total-spending-amount",
  GET_TOTAL_AND_DELIVERD_ORDER_COUNT: "/api/orders/total-and-delivered-order-count",

  // customer
  CUSTOMER_DETAILS_BY_ID: "/api/customers/get_customer/",
  CUSTOMER_SPENDING_AMOUNT: "/api/customers/customer-total-order-amount",
  // Address by lat and long coordinates
  ADDRESS_BY_LAT_LONG_CORDS: "https://api.doorway.com.bd/api/user/v2/map/geo-location",

  GET_MART_LIST: "/api/marts/get_marts",

  // Address
  ADD_STATE: "/api/shipping/state",
  LIST_STATE: "/api/shipping/state",
  DELETE_STATE: "/api/shipping/state",

  ADD_DISTRICT: "/api/shipping/district",
  LIST_DISTRICT: "/api/shipping/district",
  DELETE_DISTRICT: "/api/shipping/district",

  ADD_AREA: "/api/shipping/area",
  LIST_AREA: "/api/shipping/area",
  DELETE_AREA: "/api/shipping/area",

  // payment method urls
  ADD_PAYMENT_METHOD: "/api/shipping/payment_method",
  LIST_PAYMENT_METHOD: "/api/shipping/payment_methods",
  UPDATE_PAYMENT_METHOD: "/api/shipping/payment_method",

  // product payment method allowed
  UPDATE_PRODUCT_PAYMENT_METHOD: "/api/shipping/update_product_payment_method",
  GET_PRODUCT_PAYMENT_METHOD: "/api/shipping/get_product_payment_method",

  // Categories
  DELETE_CATEGORY: "/api/categories/delete_category",
  DELETE_SUB_CATEGORY: "/api/categories/delete_sub_category",

  // Rider
  GET_ACTIVE_RIDERS: "/api/riders/get_active_riders",
  ASSIGN_ORDER_TO_ORDER: "/api/riders/assign_order_to_order",
  GET_RIDERS: "/api/riders/get_riders",
  GET_LEAN_RIDERS: "/api/riders/get_lean_riders",
  GET_LEAN_ACTIVE_RIDERS: "/api/riders/get_lean_active_riders",
  GET_RIDER_ORDER_LIST: "/api/riders/get_rider_orders",

  // Dashboard
  TOTAL_PRODUCT_COUNT: "/api/products/total_products_count",
  TOTAL_USER_COUNT: "/api/dashboard/total_user_count",
  TOTAL_SELLER_COUNT: "/api/dashboard/total_seller_count",
  TOTAL_LIVE_PRODUCT_COUNT: "/api/products/total_live_products_count",
  TOP_SELLING_PRODUCT: "/api/dashboard/top_selleing_products",
  FEATURED_SELLING_PRODUCT: "/api/dashboard/featured_products",
  LAST_SEVEN_DAYS_CUSTOMER_LIST: "/api/dashboard/last_seven_days_customer",
  // riders
  TOTAL_RIDER_COUNT: "/api/riders/total_riders_count",
  TOTAL_ACTIVE_RIDER_COUNT: "/api/riders/total_active_riders_count",
  GET_ALL_ORDER_RIDER_HISTORY: "/api/riders/get_rider_order_history",

  ALL_lOGS: "/api/log/all-logs",
  DELETE_LOGS: "/api/log/delete-logs",
  ALL_USERS: "/api/auth/admin-user-list",

  USER_LOCATION_AND_INFO: "https://ipinfo.io?token=35e6c8aedfc3e8",

  RIDER_TRANSECTIONS: "/api/riders/rider_transection",
  RIDER_PAYMENT_RECEIVE: "/api/riders/add_rider_transection",
  RIDER_BALANCE: "/api/riders/rider-current-balance",
  RIDER_LIST: "/api/riders/get_riders",
  RIDER_BY_ID: "/api/riders/get_rider",
  RIDER_STATUS_UPDATE: "/api/riders/change_status",

  GET_ADMINS: "/api/admins/get_admins",
  UPDATE_ADMIN_TOKEN: "/api/admins/update-token",

  // categories
  ADD_BRAND: "/api/categories/add-brand",
  DELETE_BRAND: "/api/categories/delete-brand",
  BRAND_LIST: "/api/categories/brand-list",

  GET_CATEGORIES: "/api/categories/get_categories",

  // contact us
  GET_CONTACTS: "/api/contact",
  UPDATE_CONTACT_STATUS: "/api/contact",
};
